import type { AuthorRow } from "../api/client";

export function filterAuthorsByName(rows: AuthorRow[], search: string): AuthorRow[] {
  const term = search.trim().toLocaleLowerCase();
  if (!term) return rows;
  return rows.filter((row) => row.author.toLocaleLowerCase().includes(term));
}

export function averageViewsPerArticle(row: AuthorRow): number {
  return row.article_count > 0 ? row.views / row.article_count : 0;
}
